export const uid = () => Math.random().toString(36).slice(2, 10);

const ME = new Set(["me", "you", "i", "myself", "mine"]);
const LINE = /^(?:\[[^\]]{1,40}\]\s*)?(?:\d{1,2}[/.-]\d{1,2}[/.-]\d{2,4},?\s*\d{1,2}:\d{2}(?:\s?[ap]\.?m\.?)?\s*[-–]\s*)?([^:\n]{1,24}):\s+(.+)$/i;

export const parseChat = (raw) =>
  raw
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter(Boolean)
    .map((line) => {
      const m = line.match(LINE);
      if (m) {
        const who = m[1].trim().toLowerCase();
        return { id: uid(), speaker: ME.has(who) ? "me" : "them", text: m[2].trim() };
      }
      return { id: uid(), speaker: "unknown", text: line };
    });

export const withIds = (msgs) => msgs.map((m) => ({ id: uid(), speaker: m.speaker, text: m.text }));

export const dedupeAdjacent = (msgs) =>
  msgs.filter((m, i) => i === 0 || !(msgs[i - 1].text === m.text && msgs[i - 1].speaker === m.speaker));
